import { ServiceTypeSettingsPageStore } from './service-type-settings-page.store';
import { Component, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { fb } from '../../../../modules/shared/shared.global-service';
import { Card } from '@openng/optimus-ui/card';
import { TranslatePipe } from '@ngx-translate/core';
import { SwitchInputComponent } from '../../../kit/input/switch-input/switch-input.component';

@Component({
    selector: 'app-service-type-settings-page',
    templateUrl: './service-type-settings-page.component.html',
    styleUrl: './service-type-settings-page.component.scss',
    providers: [ServiceTypeSettingsPageStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Card,
        SwitchInputComponent,
        TranslatePipe,
    ],
})
export class ServiceTypeSettingsPageComponent {

    public readonly store = inject(ServiceTypeSettingsPageStore);

    // nastavení druhu služby se needituje z aplikace, control je jen pro zobrazení
    protected form = fb.group({
        multiPersonFolder: fb.control({ value: false, disabled: true }),
    });

    constructor() {
        effect(() => {
            this.form.controls.multiPersonFolder.setValue(
                this.store.multiPersonFolder(),
                { emitEvent: false },
            );
        });
    }

}
